import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
export default {
  components: {
    Modal: Modal
  },
  props: {
    backPath: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    backPrev: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      hasHelpButton: false
    };
  },
  computed: {
    title: function title() {
      return ((this.$slots.default || [])[0] || {}).text || '';
    },
    isHelpModalShown: function isHelpModalShown() {
      return useTitleData().isHelpModalShown;
    }
  },
  watch: {
    title: {
      handler: function handler() {
        useTitleData().setTitleName(this.title);
      },
      immediate: true
    },
    backPath: {
      handler: function handler() {
        useTitleData().setBackPath(this.backPath);
      },
      immediate: true
    },
    backPrev: {
      handler: function handler() {
        useTitleData().setBackPrev(this.backPrev);
      },
      immediate: true
    },
    hasHelpButton: {
      handler: function handler() {
        useTitleData().setHasHelpButton(this.hasHelpButton);
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.hasHelpButton = !!this.$slots.help;
  },
  methods: {
    back: function back() {
      if (this.backPath) {
        return this.$router.push(this.backPath);
      } else if (this.backPrev) {
        return this.$router.back();
      }
    },
    setIsHelpModalShown: function setIsHelpModalShown() {
      useTitleData().setIsHelpModalShown(false);
    }
  }
};